import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from "react-redux";
import { toast } from 'react-toastify';
import { TableDefault, Breadcrumb, Tabs } from '../../../components';
import { pathDmService } from '../../../services/Api';
import ModalDm from '../../../components/Modal/ModalDm';
import mainActions from "../../../redux/modules/main";

export class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      page: 1,
      type: 1,
      pageSize: 100,
      totalItems: 0,
      orderBy: 'Id',
      order: 'DESC',
      urlDelete: '/Pedido/Delete',
      urlEdit: '/admin/pre-cadastro/',
      urlLoad: '/Pedido/GetPreCadastroAtendente/',
      actions: [],
      openModalSincronizar: false
    };
  }
  
  propsChange = () => {
    const {loadBadgets} = this.props;
      loadBadgets(); 
  }

  componentWillMount = () => {
    const {loadBadgets} = this.props;
    loadBadgets();
    const bloquear = {
      modalHeading: 'Aprovar Registro',
      modalMessage: 'Você tem certeza que deseja aprovar este registro?',
      icon: 'check_circle',
      errorMessage: 'Não foi possível aprovar o registro.',
      successMessage: 'Registro aprovado com sucesso',
      action: async id => {
        await this.toApprovePreRegistration(id);
        loadBadgets();
      },
    };
    
    this.setState({actions: [bloquear]})
  }


  toApprovePreRegistration = async id => {
    try {
      await pathDmService(`Pedido/AprovaPrecadastro/${id}`, {});
      
    } catch (error) {
      console.log(error);
    }
  }

  toggleModal = (modal) => {
    this.setState(prevState => ({
      [modal]: !prevState[modal]
    }));
  }

  sincronizar = async () => {
    try {
      // const data = await getDmService("/Sincronizacao");
      toast.success("Sincronização realizada com sucesso.");
      this.toggleModal("openModalSincronizar")
    } catch (error) {
      this.errorHandler(error);
    }
  };

  render() {
    const {
      page,
      type,
      pageSize,
      totalItems,
      search,
      order,
      orderBy,
      urlDelete,
      urlEdit,
      urlLoad,
      actions,
      openModalSincronizar
    } = this.state;
    const {match} = this.props;
    // console.log("match", match);
    return (
      <div>
        <Breadcrumb 
          title="Pré-Cadastro" 
          description="Gerencie os Pré-Cadastro." 
          renderRight={(() => (
            <div className="breadcrumb-right-actions">
              <button
                type="button"
                className="bx--btn btn-secondary-color v-md-margin"
                onClick={() => this.setState({ openModalSincronizar: true })}
              >
                Sincronizar Dados
              </button>
            </div>
          ))()}
        />
        <section className="content-wrapper budget-management">
          <div className="user-list">
            <Tabs
              sections={[
                { title: 'Pendentes', path: `${match.url}/pendentes` },
                { title: 'Aprovados', path: `${match.url}/aprovados` }
              ]}
            />
            <Route
              path={`${match.url}/aprovados`}
              component={() => 
                (
                  <TableDefault
                    search={search}
                    type={type}
                    order={order}
                    orderBy={orderBy}
                    page={page}
                    pageSize={pageSize}
                    totalItems={totalItems}
                    urlEdit={urlEdit}
                    urlLoad={urlLoad}
                    defaultFilters="aprovado=true"
                    displayActions={false}
                    onRef={ref => (this.tableList = ref)
                    }
                  />
               )
              }
            />
            <Route
              path={`${match.url}/pendentes`}
              component={() => (
                (
                  <TableDefault
                    search={search}
                    type={type}
                    order={order}
                    orderBy={orderBy}
                    page={page}
                    pageSize={pageSize}
                    extraRows={actions}
                    totalItems={totalItems}
                    urlDelete={urlDelete}
                    urlEdit={urlEdit}
                    urlLoad={urlLoad}
                    defaultFilters="pendente=true"
                    onRef={ref => (this.tableList = ref)}
                    onDelete={this.propsChange}
                  />
               )                
              )}
            />          
         
          </div>
          <div>
            <ModalDm
              openModal={() => { this.toggleModal('openModalSincronizar') }}
              heading="Sincronizar"
              hiddenModal={() => { this.toggleModal('openModalSincronizar') }}
              openMd={openModalSincronizar}
            >
              <div>
                <div className="bx--modal-header">
                  <p className="question">
                    Tem certeza que deseja realizar a sincronização de dados?
                  </p>
                </div>
                <div className="bx--modal-footer">
                  <div className="bx--row btn-actions">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <div className="f-right">
                        <button
                          className="bx--btn btn-secondary-outlined h-sm-margin"
                          type="button"
                          onClick={() => { this.toggleModal('openModalSincronizar') }}
                        >
                          Cancelar
                        </button>
                        <button
                          className="bx--btn btn-secondary-color h-sm-margin"
                          type="button"
                          onClick={async () => {
                            await this.sincronizar()
                          }}
                        >
                          Tenho certeza
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ModalDm>
          </div>
        </section>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  badgets: state.main.badgets
});

const mapDispatchToProps = dispatch => ({
  loadBadgets() {
    return dispatch(mainActions.receiveBadget());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(List);



// WEBPACK FOOTER //
// ./src/screens/admin/PreRegistration/List.js